import * as apiDelete from 'api/ingredientCategory/DeleteIngredientCategoryIdV1';
import * as apiRestore from 'api/ingredientCategory/PostIngredientCategoryRestoreV1';
import * as apiPostSearch from 'api/ingredientCategory/PostIngredientCategorySearchV1';
import { NutriScoreCategory } from 'enums/nutriScoreCategory';

export default class IngredientCategory {
	public id: string = '';
	public name: string = '';
	public parentName: string | null = null;
	public nutriScoreCategory: NutriScoreCategory = NutriScoreCategory.StandardFood;

	public constructor(input?: apiPostSearch.ResponseIngredientCategory) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public async callApiDelete(): Promise<void> {
		await apiDelete.callApi(this.id);
	}

	public async callApiRestore(): Promise<void> {
		await apiRestore.callApi(this.id);
	}

	private mapFromApi(input: apiPostSearch.ResponseIngredientCategory) {
		this.id = input.id;
		this.name = input.name;
		this.parentName = input.parentName;
		this.nutriScoreCategory = input.nutriScoreCategory;
	}
}
